import { useCallback, useEffect, useState } from "react";

/**
 * Tracks which cloud-import batches the user has dismissed from the
 * Recent Imports feed.  Resets when the active dataset changes so a
 * batch dismissed in one dataset doesn't hide imports in another.
 */
export const useDismissedBatches = (
  datasetId: number | undefined,
): {
  dismissedBatchIds: ReadonlySet<string>;
  dismissBatch: (batchId: string) => void;
} => {
  const [dismissedBatchIds, setDismissedBatchIds] = useState<
    ReadonlySet<string>
  >(new Set());

  useEffect(() => {
    setDismissedBatchIds(new Set());
  }, [datasetId]);

  const dismissBatch = useCallback((batchId: string) => {
    setDismissedBatchIds((prev) => {
      const next = new Set(prev);
      next.add(batchId);
      return next;
    });
  }, []);

  return { dismissedBatchIds, dismissBatch };
};
